import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Manifesto from "../components/Manifesto";
import Services from "../components/Services";
import Kits from "../components/CuratedBoxes";
import HeroProduct from "../components/HeroProduct";
import Craft from "../components/Craft";
import OrderFlow from "../components/OrderFlow";
import Corporate from "../components/Corporate";
import Closing from "../components/Closing";
import InstagramGrid from "../components/InstagramGrid";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-cream text-ink">
      <Navbar />
      <main>
        <Hero />
        <Manifesto />
        <Services />
        <Kits />
        <HeroProduct />
        <Craft />
        <OrderFlow />
        <Corporate />
        <Closing />
        <InstagramGrid />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
